import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockVettingEventsHistory } from '@percent/admin-dashboard/fixtures/api/mockVettingEventsResults'

export const vettingEventsHandlers = [
  rest.get(`${config.urls.api}v1/admin/vetting-events`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockVettingEventsHistory }))
  })
]
